"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseFormSchema = void 0;
const license_schema_1 = require("../core-model-schemas/license-schema");
const license_enums_1 = require("../enums/license-enums");
const zod_1 = require("zod");
const LicenseActionsSchema = zod_1.z.object({
    hasCompletedDueDiligence: zod_1.z.boolean(),
    hasUploadedAgreement: zod_1.z.boolean(),
});
exports.LicenseFormSchema = zod_1.z
    .object({
    name: zod_1.z.string().min(1, { message: 'Name is required' }),
    actions: LicenseActionsSchema,
    ipType: license_enums_1.IPTypeSchema,
    licenseeId: zod_1.z.string().min(1, { message: 'Licensee is required' }),
    patentId: zod_1.z.string().nullish(),
    caseId: zod_1.z.string().min(1, { message: 'Case is required' }),
    verified: zod_1.z.boolean(), // When all actions are completed then the License becomes verified
    milestones: zod_1.z.array(license_schema_1.LicenseMilestoneSchema),
    startDate: zod_1.z.string().nullish(),
    terminationDate: zod_1.z.string().nullish(),
})
    .refine((data) => !data.startDate ||
    !data.terminationDate ||
    data.startDate <= data.terminationDate, {
    message: 'Start date must be before termination date',
    path: ['startDate'], // highlight startDate field
});
